// Keys are dated: when a key's stored schema changes shape, mint a new dated
// key and move the old one into the trash list below, removed on every
// boot; the RESET_STORAGE sweep instead wipes every unknown key once, on a
// browser's first boot.
export const AUTHTOKEN = 'r-auth-token-10/23/2020';
export const ADDRESSES_SENT_TXS = 'r-addresses-sent-txs-04/21/2026';
export const COOKIES_BANNER_WAS_CLOSED =
  'r-cookies-banner-was-closed-01/13/2020';
export const UTM_TAGS = 'r-utm-tags-12-27-2022';
export const IS_COLOR_THEME_DARK = 'r-is-color-theme-dark-03-04-2024';
export const COMMUNITY_SORT = 'r-qualification-sort-05-18-2026';
export const MARKETS_LAST_VISITED_AT = 'r-markets-last-visited-at-05-26-2026';
export const INVITE_CODE = 'r-invite-code-06-29-2026';

const RESET_STORAGE = 'r-reset-storage-10/11/2023';

export function sweepStorage(): void {
  const resetDone = localStorage.getItem(RESET_STORAGE);
  if (resetDone == null || resetDone === '') {
    Object.keys(localStorage).forEach((key) => {
      if (![AUTHTOKEN, COOKIES_BANNER_WAS_CLOSED].includes(key)) {
        localStorage.removeItem(key);
      }
    });
    localStorage.setItem(RESET_STORAGE, 'true');
  }

  // Entries dated on/before the RESET_STORAGE sweep date are omitted — the
  // sweep already wipes every unknown key on a browser's first boot.
  const trash = [
    'r-market-moved-hint-hidden-06-08-2026',
    'r-addresses-sent-txs-12/06/2025',
    'r-addresses-sent-txs-12/05/2025',
    'r-addresses-sent-txs-11/10/2025',
    'r-addresses-sent-txs-10/22/2025',
    'r-addresses-sent-txs-10/21/2025',
    'r-addresses-sent-txs-27/04/2025',
    'r-addresses-sent-txs-12/01/2025',
    'r-addresses-sent-txs-11/12/2024',
    'r-addresses-sent-txs-11/11/2024',
    'r-addresses-sent-txs-11/07/2024',
    'r-addresses-sent-txs-10/07/2024',
    'r-addresses-sent-txs-10/05/2024',
    'r-addresses-sent-txs-11/27/2023',
    'r-cache-page-top-keys-table-02-07-2024',
  ];
  trash.forEach((key) => localStorage.removeItem(key));
}

sweepStorage();
